import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ResponsiveLayout from '../components/layout/responsive-layout';
import usePageViews from '../hooks/ga4/usePageViews';
import NotificationSnackComponent from '../features/notifications/notification-snack.component';
import ErrorSnackContainer from '../components/feedback/errors/error-snack.container';
import SuccessSnackContainer from '../components/feedback/success/success-snack.container';
import { Box, CircularProgress } from '@mui/material';
import {
  ensureBalance,
  prefetchUserInfo,
  prefetchMarketHours,
  prefetchUnderlyingsMap,
} from '@oai-frontend-monorepo/api';
import { useUnderlyingMapStore } from '@oai-frontend-monorepo/state-management';
import { _renewToken } from '../libs/okta/useRenewOktaToken';
import { captureException } from '@sentry/react';

const AppRoot = () => {
  usePageViews();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  console.log('AppRoot rendered');

  // useEffect(() => {
  //   const init = async () => {
  //     const url = location.pathname + location.search;

  //     if (url.includes('subscribed')) {
  //       setLoading(true);

  //       const ensureGroup = async (attempt = 1): Promise<boolean> => {
  //         if (attempt > 20) return false;
  //         await new Promise((r) => setTimeout(r, 500));

  //         console.log(
  //           'Checking subscription group membership, attempt:',
  //           attempt
  //         );

  //         const token = await _renewToken();
  //         if (
  //           !token?.groups?.includes('Subscribers') &&
  //           !token?.groups?.includes('Traders')
  //         ) {
  //           return ensureGroup(attempt + 1);
  //         }
  //         return true;
  //       };

  //       const ok = await ensureGroup();
  //       if (!ok) {
  //         captureException(
  //           new Error('Subscription group check failed after multiple attempts')
  //         );
  //         return alert('Subscription group check failed.');
  //       }

  //       try {
  //         await Promise.all([
  //           ensureBalance(),
  //           prefetchUserInfo(),
  //           prefetchMarketHours(),
  //           prefetchUnderlyingsMap({
  //             onSuccess: useUnderlyingMapStore.getState().setMap,
  //           }),
  //         ]);
  //       } catch (err) {
  //         console.error('Prefetch error', err);
  //       } finally {
  //         setLoading(false);
  //       }

  //       navigate('/dashboard');
  //       return;
  //     }
  //   };

  //   init();
  // }, [location.pathname, location.search, navigate]);

  if (loading) {
    return (
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100vw"
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress size={64} />
      </Box>
    );
  }

  return (
    <ResponsiveLayout>
      <Suspense
        fallback={
          <div className="flex size-full items-center justify-center">
            <h1>loading</h1>
          </div>
        }
      >
        <Outlet />
        <NotificationSnackComponent />
        <ErrorSnackContainer />
        <SuccessSnackContainer />
      </Suspense>
    </ResponsiveLayout>
  );
};

export default AppRoot;
